<template>
    <div class="helpdesk-status-note helpdesk-dropdown-wrapper filter-open no-select"
         v-if="topic.board_type === 'helpdesk'"
         :class="'filter-' + topic.ticket_status"
         @click="helpdeskFilterOpen = !helpdeskFilterOpen">
                <span class="current-helpdesk-filter filter-open"
                      :class="'filter-' + topic.ticket_status"> <template
                        v-if="topic.ticket_status === 'open' || topic.ticket_status === '' || !topic.ticket_status">
                    Open </template> <template v-else-if="topic.ticket_status === 'hold'">
                    {{ translations['support.awaiting_reply'] }} </template> <template
                        v-else-if="topic.ticket_status === 'closed'"> {{
                    translations['fields.closed'] }} </template>
                </span>
        <i class="fa fa-caret-down"></i>
        <div class="helpdesk-dropdown-menu deep-shadow"
             :class="{'open-dropdown' : helpdeskFilterOpen}">
                <span class="helpdesk-filter hover-opacity filter-open"
                      @click="setTopicHelpdeskFilter('open', topic)">Open</span> <span
                class="helpdesk-filter hover-opacity filter-hold"
                @click="setTopicHelpdeskFilter('hold', topic)">{{
            translations['helpdesk.ticket_pending'] }}</span> <span
                class="helpdesk-filter hover-opacity filter-closed"
                @click="setTopicHelpdeskFilter('closed', topic)">{{
            translations['helpdesk.ticket_closed'] }}
                </span>
        </div>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js'

    export default {
        mixins: [Global],

        data() {
            return {
                helpdeskFilterOpen: false,
            }
        },

        props: {
            topic: {
                required: true
            }
        },

        methods: {
            setTopicHelpdeskFilter(status, topic) {
                let self = this;

                if (topic.ticket_status !== status) {
                    this.$store.dispatch(
                        {
                            type: 'activeDataAction',
                            data: {
                                model: 'Topic',
                                crud_method: 'update',
                                sub_path: '/comments/' + topic.post_id,
                                save_data: {
                                    'conversation[id]': topic.id,
                                    id: topic.post_id,
                                    ticket_status: status,
                                },
                                success_callback: function (response) {
                                    success_callback(response)
                                }
                            }
                        }
                    );

                    let success_callback = function (response) {
                        self.$store.commit('setTopicHelpdeskFilter', {status: status, topic: topic});
                    }
                }
            },
        }
    }
</script>